import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

// Create the context
const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
    const [snackbarMessage, setSnackbarMessage] = useState(null);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('info');

    const showSnackbar = (message, severity = 'info') => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setIsSnackbarOpen(true);
    };

    const hideSnackbar = () => {
        setSnackbarMessage(null);
        setSnackbarSeverity('info');
        setIsSnackbarOpen(false);
    };

    return (
        <AppContext.Provider value={{ snackbarMessage, snackbarSeverity, isSnackbarOpen, showSnackbar, hideSnackbar }}>
            {children}
        </AppContext.Provider>
    );
};

AppProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

// Custom hook to use the AppContext
export const useAppContext = () => {
    return useContext(AppContext);
};